import { $3l5vvh8yg0ier as $ } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { AbortFlowException2zdgh4w7z3hep as AbortFlowException } from './internal/FlowExceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from './FlowCollector.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { checkOwnershipoyid8o0pxxr7 as checkOwnership } from './internal/FlowExceptions.common.mjs';
import { ensureActive2yo7199srjlgl as ensureActive } from '../Job.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function takeWhile(_this__u8e3s4, predicate) {
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new (takeWhile$$inlined$unsafeFlow$1())(_this__u8e3s4, predicate);
}
var takeWhile$$inlined$unsafeFlow$1$collect$2Class;
function takeWhile$$inlined$unsafeFlow$1$collect$2() {
  if (takeWhile$$inlined$unsafeFlow$1$collect$2Class === VOID) {
    class $_0 {
      constructor($predicate, $$this$flow) {
        this.$predicate_1 = $predicate;
        this.$$this$flow_1 = $$this$flow;
      }
      *emit_53hnst_k$(value, $completion) {
        var tmp;
        if (yield* $(this.$predicate_1(value, $completion), $completion)) {
          yield* this.$$this$flow_1.emit_t92u1f_k$(value, $completion);
          tmp = true;
        } else {
          tmp = false;
        }
        if (!tmp) {
          throw AbortFlowException().new_kotlinx_coroutines_flow_internal_AbortFlowException_hca45b_k$(this);
        }
        return Unit_instance;
      }
      emit_t92u1f_k$(value, $completion) {
        return this.emit_53hnst_k$(value, $completion);
      }
    }
    initMetadataForClass($_0, VOID, VOID, VOID, [FlowCollector()], [1]);
    takeWhile$$inlined$unsafeFlow$1$collect$2Class = $_0;
  }
  return takeWhile$$inlined$unsafeFlow$1$collect$2Class;
}
var takeWhile$$inlined$unsafeFlow$1Class;
function takeWhile$$inlined$unsafeFlow$1() {
  if (takeWhile$$inlined$unsafeFlow$1Class === VOID) {
    class $ {
      constructor($this_takeWhile, $predicate) {
        this.$this_takeWhile_1 = $this_takeWhile;
        this.$predicate_1 = $predicate;
      }
      *collect_ooju95_k$(collector, $completion) {
        // Inline function 'kotlinx.coroutines.flow.collectWhile' call
        var this_0 = this.$this_takeWhile_1;
        var collector_0 = new (takeWhile$$inlined$unsafeFlow$1$collect$2())(this.$predicate_1, collector);
        try {
          yield* this_0.collect_aksokr_k$(collector_0, $completion);
        } catch ($p) {
          if ($p instanceof AbortFlowException()) {
            var e = $p;
            checkOwnership(e, collector_0);
            // Inline function 'kotlin.js.getCoroutineContext' call
            var tmp$ret$2 = $completion.get_context_h02k06_k$();
            ensureActive(tmp$ret$2);
          } else {
            throw $p;
          }
        }
        return Unit_instance;
      }
      collect_aksokr_k$(collector, $completion) {
        return this.collect_ooju95_k$(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    takeWhile$$inlined$unsafeFlow$1Class = $;
  }
  return takeWhile$$inlined$unsafeFlow$1Class;
}
//region block: exports
export {
  takeWhile as takeWhile2lajz05xm93j8,
};
//endregion

//# sourceMappingURL=Limit.mjs.map
